<div class="delivery" [ngClass]="selected ? 'selected' : null">
    <div class="checkbox" style="flex: 0">
        <label *ngIf="carrierHasBluechat">
            <input type="checkbox" (click)="select.emit(!selected)" [disabled]="!userCanCreateNote" [ngModel]="selected">
            <i class="fa checkbox-icon"></i>
        </label>
    </div>

    <div class="left-side">
        <h3>
            <span [popover]="salesOrderPopTemplate" placement="top" container="body" triggers="mouseenter:mouseleave">
                <span [i18n]="'bluechat.search.delivery.delivery-number'"></span>&nbsp;#{{delivery.deliveryNumber}}
            </span>
        </h3>
        <ng-template #salesOrderPopTemplate>
            <chp-delivery-and-sales-order-numbers
                [deliveryNumbers]="[delivery.deliveryNumber]"
                [salesOrderNumbers]="[delivery.salesOrderNumber]">
            </chp-delivery-and-sales-order-numbers>
        </ng-template>
        <div class="address-and-planned-delivery">
            <div class="address">
                <h3>
                    <span [i18n]="'bluechat.search.delivery.origin'"></span>:&nbsp;
                    <a class="cmaweb-link" *ngIf="canManageLocations" [href]="link.goToLocationGlid(delivery.origin.glid)" target="_blank">{{delivery.origin.glid}}</a>
                    <span *ngIf="!canManageLocations">{{delivery.origin.glid}}</span>
                </h3>
                <p>{{delivery.origin.format()}}</p>
            </div>
            <div class="address">
                <h3>
                    <span [i18n]="'bluechat.search.delivery.destination'"></span>:&nbsp;
                    <a class="cmaweb-link" *ngIf="canManageLocations" [href]="link.goToLocationGlid(delivery.destination.glid)" target="_blank">{{delivery.destination.glid}}</a>
                    <span *ngIf="!canManageLocations">{{delivery.destination.glid}}</span>
                </h3>
                <p>{{delivery.destination.format()}}</p>
            </div>
            <div class="planned-delivery">
                <h3><span [i18n]="'bluechat.search.delivery.planned-delivery'"></span>:</h3>
                <p>{{delivery.destination.plannedDeliveryDateTime != null ? (delivery.destination.plannedDeliveryDateTime | date:'y-MM-dd') : '-'}}</p>
            </div>
        </div>
    </div>

    <div class="eta-status">
        <span class="status bg large">
            <app-bluechat-delivery-status
                                          [timezoneOffset]="delivery.destination.timezoneOffset"
                                          [eta]="delivery.destination.latestEtaDateTime"
                                          [status]="delivery.status"
                                          [etaType]="delivery.destination.latestEtaType"
                                          (etaComponentClicked)="canReadEtaDetails ? showEtaDetailsForDelivery(delivery.deliveryNumber, delivery.destination.latestEtaReportId, delivery.destination.glid): null">
            </app-bluechat-delivery-status>
        </span>
    </div>

    <div class="right-side">
        <div class="notes">
            <h3><span [i18n]="'bluechat.search.delivery.notes'"></span>: </h3>
            <div class="counter-wrapper">
                <span class="counter" (click)="noteSummaryOpened = !noteSummaryOpened">
                    {{delivery.notes.length}}
                </span>
                <div *ngIf="noteSummaryOpened" class="dropdownListNotes">
                    <ul>
                        <li *ngFor="let note of delivery.notes">
                            <a target="_blank" class="dropdownListNotes-link" [href]="note.link">{{note.subject}}</a>
                            <div class="date-noteCreated">
                                <span class="date-noteCreated-label" [i18n]="'bluechat.detail.delivery.note-created'"></span>
                                <span class="date"> {{note.creationDate | date : dateFormat}}</span>
                            </div>
                        </li>
                    </ul>
                </div>
            </div>
        </div>
        <button  class="btn btn-primary" (click)="createNoteClicked.emit()" *ngIf="carrierHasBluechat" [disabled]="!userCanCreateNote">
            <span [i18n]="'bluechat.search.delivery.create-note'"></span>&nbsp;<i class="fa fa-comment-medical"></i>
        </button>
        <span *ngIf="!carrierHasBluechat" [i18n]="'bluechat.search.delivery.carrier-not-enabled'"></span>
        <div *ngIf="!loadStatusAllowNoteCreation">
            <span [i18n]="[{target:'innerHTML', key: 'bluechat.search.delivery.invalid-status'}]"></span> <span [i18n]="loadStatusI18nKey"></span>
        </div>
    </div>
</div>

<div class="overlay" *ngIf="showEtaDetails">
    <app-eta-details-popup [deliveryNumber]="deliveryNumberForEtaDetails"
                           [etaDestinationGlid]="targetGlidForEtaDetails"
                           [latestEtaReportId]="latestEtaReportIdForEtaDetails"
                           (close)="hideEtaDetails()"></app-eta-details-popup>
</div>
